











import Vue from 'vue'
import { DescExpanderElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DescExpanderEl',
  props: {
    templateItemData: {
      type: Object as () => DescExpanderElInterface,
      required: true
    }
  }
})
